import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../images/Loading_icon.gif";
import DatabaseResult from "../components/ProjectDetails/DatabaseResult";
import "../styles/searchConsultants.css";
import Swal from "sweetalert2";
import $ from "jquery";
import ProjectTitle from "../components/ProjectDetails/ProjectTitle";
import { useParams } from "react-router-dom";
import { UrlContext } from "../contexts/UrlContext";
import { AppContext } from "../contexts/AppContext";

export default function SearchDatabase() {
  useEffect(() => {
    document.title = "Search Database";
  }, []);
  const searchData = JSON.parse(localStorage.getItem('searchData'))
  const id = useParams().id;
  const [project, setProject] = useState({});
  const { API_URL } = useContext(UrlContext);
  const [searchResults, setSearchResults] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allWordList, setAllWordList] = useState([]);
  const [allWordListCount, setAllWordListCount] = useState(0);
  const [btnValue, setBtnValue] = useState(searchData.buttonClicked);
  const [entireSearch, setEntireSearch] = useState(false);
  const [entirePage, setEntirePage] = useState(1);
  const [entireWordListCount, setEntireWordListCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataFetched, setAllDataFetched] = useState(false);
  const [inputData, setInputData] = useState({
    country: "",
    keywords: "",
  });

  useEffect(() => {
    const url = `${API_URL}get-project-name/` + id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProject(data.project);
      })
      .catch((err) => console.log(err));
  }, [id]);

  useEffect(() => {
    if (btnValue) {
      handleSearch(btnValue);
    }
  }, [btnValue, pageNumber]);

  const handleSearch = (btnValue) => {
    if (pageNumber === 1) {
      setLoading(true);
    }
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const data = { ...searchData, buttonName: btnValue };
    const url = `${API_URL}database-search-result/` + pageNumber;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          if (pageNumber === 1) {
            var excludedWords = new Set(["AND", "OR", "NOT", "(", ")", '"']);
            function splitStringWithQuotes(str) {
              const regex = /"([^"]+)"|\S+/g;
              const matches = str.match(regex);
              return matches
                ? matches.map((match) => match.replace(/"/g, ""))
                : [];
            }
            function processQuotedPhrases(str) {
              const regex = /"([^"]+)"/g;
              const matches = str.match(regex);
              return matches
                ? matches.map((match) => match.replace(/"/g, ""))
                : [];
            }

            if (searchData) {
              var countryWords = searchData.country ? [searchData.country] : [];
              var keywordsWords = splitStringWithQuotes(searchData.keywords);
              var quotedPhrases = processQuotedPhrases(searchData.keywords);
              var newQuotedPhrases = quotedPhrases.filter(
                (phrase) => !keywordsWords.includes(phrase)
              );
              if (searchData.company) {
                var companyWords = splitStringWithQuotes(searchData.company);
                var quotedCompanyPhrases = processQuotedPhrases(searchData.company);
                var newQuotedCompanyPhrases = quotedCompanyPhrases.filter(
                  (phrase) => !companyWords.includes(phrase)
                );
                var allWords = [
                  ...countryWords,
                  ...keywordsWords,
                  ...newQuotedPhrases,
                  ...companyWords,
                  ...newQuotedCompanyPhrases,
                ];
              } else {
                var allWords = [
                  ...countryWords,
                  ...keywordsWords,
                  ...newQuotedPhrases,
                ];
              }
            }
            var normalizedWords = allWords
              .filter((item) => item !== "" && !excludedWords.has(item))
              .map((item) => item.replace(/(\(|\))/g, "").toLowerCase());

            setAllWordList(normalizedWords);
          }
          setDataFetched(true);
          setLoading(false);
          setAllDataFetched(true);
          setSearchResults([...searchResults, ...data.experts]);
          if (pageNumber === 1) {
            setTimeout(() => {
              setAllWordListCount(1);
            }, 200);
          }

          if (data.experts.length === 50) {
            setPageNumber(pageNumber + 1);
          } else {
            setTimeout(() => {
              setAllWordListCount(2);
            }, 200);
          }
        } else {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  // useEffect(() => {
  //   if (entireSearch) {
  //     handleEntireSearch();
  //   }
  // }, [entireSearch, entirePage]);

  // const handleEntireSearch = () => {
  //   if (entirePage === 1) {
  //     setLoading(true);
  //     setDataFetched(false);
  //     setSearchResults([]);
  //   }
  //   const ephToken = localStorage.getItem("eph-token");
  //   const token = JSON.parse(ephToken).value;
  //   const data = {
  //     ...searchData,
  //     search_type: "entireDatabase",
  //     buttonName: "HerokuSearch",
  //   };
  //   const url = `${API_URL}database-search-result/` + entirePage;
  //   fetch(url, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-access-token": token,
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         if (entirePage === 1) {
  //           console.log("entirePage 1");
  //           var excludedWords = new Set(["AND", "OR", "NOT", "(", ")", '"']);
  //           console.log("excludedWords", excludedWords);
  //           function splitStringWithQuotes(str) {
  //             const regex = /"([^"]+)"|\S+/g;
  //             const matches = str.match(regex);
  //             return matches
  //               ? matches.map((match) => match.replace(/"/g, ""))
  //               : [];
  //           }
  //           function processQuotedPhrases(str) {
  //             const regex = /"([^"]+)"/g;
  //             const matches = str.match(regex);
  //             return matches
  //               ? matches.map((match) => match.replace(/"/g, ""))
  //               : [];
  //           }
  //           if (inputData && inputData.keywords) {
  //             var countryWords = inputData.country ? [inputData.country] : [];
  //             var keywordsWords = splitStringWithQuotes(inputData.keywords);
  //             var quotedPhrases = processQuotedPhrases(inputData.keywords);
  //             var newQuotedPhrases = quotedPhrases.filter(
  //               (phrase) => !keywordsWords.includes(phrase)
  //             );
  //             var allWords = [
  //               ...countryWords,
  //               ...keywordsWords,
  //               ...newQuotedPhrases,
  //             ];
  //           }
  //           var normalizedWords = allWords
  //             .filter((item) => item !== "" && !excludedWords.has(item))
  //             .map((item) => item.replace(/(\(|\))/g, "").toLowerCase());

  //           setAllWordList(normalizedWords);
  //           console.log("normalizedWords", normalizedWords);
  //         }
  //         setDataFetched(true);
  //         setLoading(false);
  //         setAllDataFetched(true);
  //         setSearchResults([...searchResults, ...data.experts]);
  //         if (entirePage === 1) {
  //           setTimeout(() => {
  //             setEntireWordListCount(1);
  //           }, 200);
  //         }

  //         if (data.experts.length === 50) {
  //           setEntirePage(entirePage + 1);
  //         } else {
  //           setTimeout(() => {
  //             setEntireWordListCount(2);
  //           }, 200);
  //         }
  //       } else {
  //         setLoading(false);
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: "Something went wrong!",
  //         });
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };

  function doSearch(text) {
    if (window.find && window.getSelection) {
      document.designMode = "on";
      var sel = window.getSelection();
      sel.collapse(document.body, 0);

      while (window.find(text)) {
        document.execCommand("HiliteColor", false, "yellow");
        sel.collapseToEnd();
      }
      document.designMode = "off";
    } else if (document.body.createTextRange) {
      var textRange = document.body.createTextRange();
      while (textRange.findText(text)) {
        textRange.execCommand("BackColor", false, "yellow");
        textRange.collapse(false);
      }
    }
  }

  useEffect(() => {
    for (var i = 0; i < allWordList.length; i++) {
      doSearch(allWordList[i]);
    }
    $(".info-div1-scroll span:first-child").attr("class", "yellowId");
    $(".info-div2-scroll span:first-child").attr("class", "yellowId");

    $(".search-con-table #db-table-row").each(function () {
      var infoDiv1 = $(this).find(".info-div1-scroll:first");
      var infoDiv2 = $(this).find(".info-div2-scroll:first");

      var yellowIdSpan1 = infoDiv1.find(".yellowId");
      var yellowIdSpan2 = infoDiv2.find(".yellowId");

      if (yellowIdSpan1.length > 0) {
        var scrollTopPosition1 =
          yellowIdSpan1.offset().top -
          infoDiv1.offset().top +
          infoDiv1.scrollTop();
        infoDiv1.animate({ scrollTop: scrollTopPosition1 }, 700);
      }

      if (yellowIdSpan2.length > 0) {
        var scrollTopPosition2 =
          yellowIdSpan2.offset().top -
          infoDiv2.offset().top +
          infoDiv2.scrollTop();
        infoDiv2.animate({ scrollTop: scrollTopPosition2 }, 700);
      }
    });

    if (allWordListCount !== 1) {
      setAllDataFetched(false);
    }
    if (entireWordListCount !== 1) {
      setAllDataFetched(false);
    }
  }, [allWordListCount, entireWordListCount]);
  return (
    <>
      <ProjectTitle project={project} />

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <img src={LoadingIcon} alt="Loading..." style={{ height: "50px" }} />
        </div>
      ) : (
        <>
          {dataFetched && (
            <DatabaseResult
              searchResults={searchResults}
              projectId={id}
              allDataFetched={allDataFetched}
              setEntireSearch={setEntireSearch}
            />
          )}
        </>
      )}
    </>
  );
}
